/**
 * @author taulmax
 * @date 2024.10.07
 * @description 레이아웃 스크린 아이디 컴포넌트
 */
const ScreenId = ({ sid }: { sid?: string }) => {
  return (
    <div className="!w-full !h-10 !flex !justify-end !items-center !bg-[#24292F] !text-white !font-bold !pr-5">
      SID: {sid}
    </div>
  );
};

export default ScreenId;
